import React, { useState, useEffect } from 'react';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../shared/ShowError';
import Laoding from '../shared/Laoding';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PrintContraxtBill from '../prints/PrintContraxtBill.jsx';
import { Dialog } from 'primereact/dialog';
import GeneralDialogFooter from '../shared/GeneralDialogFooter.jsx';


export default function ShowMyContracts(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [contracts, setContracts] = useState([]);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [downloadBillPdfFormVisible, setDownloadBillPdfFormVisible] = useState(false);
    const [contract, setContract] = useState(null);
    const [billParams, setBillParams] = useState(null);
    const [printData, setPrintData] = useState(null);

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = function(){
        setLoading(true);
        var params = {
            login:util.getLoginDto(), 
            userId:"",
            mobile:"",
            fromContractNo:0,
            toContractNo:0,
            searchText:"",
            productId:"",
            cityId:"",
            provinceId:0,
        };
        var url = config.Server+`/contract/to-client/list`;
        console.log("params in show summary is>", params);
        console.log("url in show summary is>", url);
        
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("resopnse is> ", response);
                var cn = util.getSoftwareTargetContractNo();
                if(cn){
                    if(cn != ""){
                        if(parseInt(cn) > 0){
                            for(var i=response.length-1;i>=0;i--){
                                if(response[i].contract.contractNo != parseInt(cn)){
                                    response.splice(i, 1);
                                }
                            }
                        }
                    }
                }
                setContracts(response);
                setLoading(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                //setLoading(false);
            }
        })
        .catch(error => {
        console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            //setLoading(false);
        });

    }
    const onContractRowPrintClick = function(c, cInd){
        console.log("c is>", c)
        var contract = c.contract;
        console.log("contract is>", contract)
        setContract(c);

        setDownloadBillPdfFormVisible(true);
        setBillParams(null);
        setPrintData(null);

        var params = {
            param1:"", 
            param2:"", 
            param3:"", 
            param4:"", 
            param5:"", 
        };
        var url = config.Server+`/basic/bill-print/parameters/get`;
        
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                setBillParams(response);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                //setLoading(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            //setLoading(false);
        });

    }
    const onActiveContractInOtherSystemClick = function(c, cInd){
        
        var url = config.HanaAccUrl + "/Client/CheckContract?taxMemory=" + c.contract.otherSystemIdentity;
        
        window.open(url);
    }
    const printBill = function(ind){
        var tr = contract.contract.transactions[ind];
        var res = {
            issueDate: tr.transactionDate,
            contractNo: contract.contract.contractNo,
            price: tr.amount - tr.tax + tr.discount,
            discount: tr.discount,
            tax: tr.tax,
            purePrice: tr.amount,
            stuffTitle: 0,
            modules:[],
            parameters: [],
            companyDetail: contract.contract.companyDetail,
            city:contract.contract.city,
            user:contract.contract.user
        }
        if(tr.transactionType.id == util.ContractTransactionTypes.Buy){
            res.stuffTitle = "خرید " + contract.contract.product.productType.title;
            res.modules = [...contract.contract.product.modules];
            res.parameters = [...contract.contract.parameters];
        }
        else if(tr.transactionType.id == util.ContractTransactionTypes.Recontinue){
            res.stuffTitle = "تمدید مجوز " + contract.contract.product.productType.title;
            res.modules = [...contract.contract.product.modules];
            res.parameters = [...contract.contract.parameters];
        }
        else if(tr.transactionType.id == util.ContractTransactionTypes.PromoteModule){
            res.stuffTitle = "ارتقاء ماژول های قرارداد " + contract.contract.product.productType.title;
            res.modules = [...tr.propmotedModules];
            res.parameters = [];
        }
        else if(tr.transactionType.id == util.ContractTransactionTypes.PromoteParameter){
            var prs = [];
            for(var i=0;i<tr.promotedParameters.length;i++){
                if(parseInt(tr.promotedParameters[i].value)>0){
                    var p = {intValue:parseInt(tr.promotedParameters[i].value)};
                    if(tr.promotedParameters[i].name == "maxClientNo") p["parameterType"] = {id:util.ContractParameterTypes.MaxClientNo, title:"حداکثر تعداد دستگاه نصب"};
                    else if(tr.promotedParameters[i].name == "maxVisitorNo") p["parameterType"] = {id:util.ContractParameterTypes.MaxVisitorNo, title:"حداکثر تعداد ویزیتور"};
                    else if(tr.promotedParameters[i].name == "maxStudentNo") p["parameterType"] = {id:util.ContractParameterTypes.MaxStudentNo, title:"حداکثر تعداد دانش آموز"};
                    else if(tr.promotedParameters[i].name == "maxSchoolNo") p["parameterType"] = {id:util.ContractParameterTypes.MaxSchoolNo, title:"حداکثر تعداد مدرسه"};
                    else if(tr.promotedParameters[i].name == "maxMemberNo") p["parameterType"] = {id:util.ContractParameterTypes.MaxMemberNo, title:"حداکثر تعداد عضو"};
                    else if(tr.promotedParameters[i].name == "maxBillNo") p["parameterType"] = {id:util.ContractParameterTypes.MaxBillNo, title:"حداکثر تعداد صورتحساب در سال"};
                    prs.push(p);
                }
            }
            res.stuffTitle = "ارتقاء پارامترهای قرارداد " + contract.contract.product.productType.title;
            res.modules = [];
            res.parameters = prs;
        }

        setPrintData(res)
    }
    const btnPromoteParameterClick = function(c, cInd){
        util.saveClientContract(c);
        var osd = util.getOtherSystemDetail();
        osd.enName = c.contract.product.enName;
        util.saveOtherSystemDetail(osd.otherSystemIdentity, osd.mobile, osd.firstname, osd.lastname, osd.enName, osd.companyTitle);
        setRedirectUrl("/contract/paremeter/promote");
    }
    const btnPromoteModulesClick = function(c, cInd){
        util.saveClientContract(c);
        var osd = util.getOtherSystemDetail();
        osd.enName = c.contract.product.enName;
        util.saveOtherSystemDetail(osd.otherSystemIdentity, osd.mobile, osd.firstname, osd.lastname, osd.enName, osd.companyTitle);
        setRedirectUrl("/contract/module/promote");
    }
    const btnRecontinueClick = function(c, cInd){
        var osd = util.getOtherSystemDetail();
        osd.enName = c.contract.product.enName;
        util.saveOtherSystemDetail(osd.otherSystemIdentity, osd.mobile, osd.firstname, osd.lastname, osd.enName, osd.companyTitle);
        var modules = [];
        var buy = {
            productId:c.contract.id,
            enName:c.contract.product.enName,
            buyGoal:"recontinue",
            productType:0,
            modules:modules,
            parameters :{
                maxClientNo:0,
                maxVisitorNo:0,
                maxStudentNo:0,
                maxSchoolNo:0,
                maxMemberNo:0,
                maxBillNo:0
            },
            price:c.contract.nextRecontinuePrice,
            discountToken:"",
            discountMobile:"",

        };
        util.saveBuy(buy);
        util.saveIpgTransactionAmount(c.contract.nextRecontinuePrice);
        util.saveIpgTransactionType(util.WallerTransactionTypes.RecontinueContract);
        util.saveBeforeIpgUrl("ShowMyContract");
        setRedirectUrl("/ipg/select");

    }
    const showContract = function(c, cInd){
        return(
            <Row style={{margin:"10px 0px 0px 0px"}}>
                <Col md={12} style={{border:"1px solid #b0b0b0", boxSizing:"border-box", padding:"10px", borderRadius:"10px", position:"relative", backgroundColor:(cInd%2==1)?"#efefef":"#FFF"}}>
                    <Row style={{borderBottom:"1px dashed #b0b0b0", paddingBottom:"10px"}}>
                        <Col md="4" style={{textAlign:"right", fontWeight:"bold"}}>شماره قرارداد: {util.toPersianDigits(c.contract.contractNo)}</Col>
                        <Col md="4" style={{textAlign:"right"}}>نوع محصول: {c.contract.product.productType.title}</Col>
                        <Col md="4" style={{textAlign:"right"}}>نام موسسه: {c.contract.companyDetail.title} ({c.contract.companyDetail.isPersonal?"حقیقی" + ": " + util.toPersianDigits(c.contract.companyDetail.personNationalId):"حقوقی" + ": "+util.toPersianDigits(c.contract.companyDetail.companyNationalId)})</Col>
                    </Row>
                    {
                        c.contract.parameters.length>0?
                    <Row style={{marginTop:"10px", borderBottom:"1px dashed #b0b0b0", paddingBottom:"10px"}}>
                        <Col md={8}>
                            پارامتر ها:<br/>
                            {
                                c.contract.parameters.map((pr, prInd)=>{
                                    return(
                                        <>
                                            &nbsp;&nbsp;<label>{pr.parameterType.title}:&nbsp;{pr.intValue} </label><br/>
                                        </>
                                    )
                                })
                            }
                        </Col>
                        {
                        c.canBePromoteParameters?
                        <Col md="4" style={{textAlign:"right"}}>
                            <Button severity="secondary" onClick={()=>{btnPromoteParameterClick(c, cInd)}} style={{borderRadius:"5px"}}>ارتقاء پارامترهای قرارداد</Button>
                        </Col>
                        :<></>
                        }
                    </Row>
                    :<></>
                    }
                    <Row style={{marginTop:"10px", borderBottom:"1px dashed #b0b0b0", paddingBottom:"10px"}}>
                        <Col md={12}>
                            ماژول های نصب شده:&nbsp;
                            {
                                c.contract.product.modules.map((m, mInd)=>{
                                    return(
                                        <>
                                            <label>{m.title},&nbsp; </label>
                                        </>
                                    )
                                })
                            }
                        </Col>
                    </Row>
                    {
                        c.promoteAbleModules.length>0?                
                    <Row style={{marginTop:"10px", borderBottom:"1px dashed #b0b0b0", paddingBottom:"10px"}}>
                        <Col md={8}>
                            ماژول های قابل خرید:&nbsp;
                            {
                                c.promoteAbleModules.map((m, mInd)=>{
                                    return(
                                        <>
                                            <label>{m.title},&nbsp; </label>
                                        </>
                                    )
                                })
                            }
                        </Col>
                        {
                            c.canBePromoteModules?
                        <Col md="4" style={{textAlign:"right"}}>
                            <Button severity="success" onClick={()=>{btnPromoteModulesClick(c, cInd)}} style={{borderRadius:"5px"}}>ارتقاء  ماژول های قرارداد</Button>
                        </Col>
                        :<></>
                        }
                    </Row>
                    :
                    <></>
                    }
                    <Row style={{marginTop:"10px", borderBottom:"1px dashed #b0b0b0", paddingBottom:"10px"}}>
                        <Col md="4" style={{textAlign:"right", color:((c.canBeRecontinued)&&(c.daysToExpired==0))?"#ff0000":((c.canBeRecontinued)&&(c.daysToExpired>0))?"#ee931bff":"#1ea01eff"}}>تاریخ انقضاء: {util.toPersianDigits(util.SeperateDate(c.contract.expireDate))}</Col>
                        {
                            c.canBeRecontinued?
                            <>
                                <Col md="4" style={{textAlign:"right"}}>
                                    {
                                        c.daysToExpired>0?
                                        <>
                                            <label>فقط {util.toPersianDigits(c.daysToExpired)} روز تا انقضای قرارداد </label>
                                            <br/>
                                            <label style={{color:"#000"}}>مبلغ تمدید : {util.toPersianDigits(util.SeperatePrice(c.contract.nextRecontinuePrice))}</label>
                                        </>
                                        :
                                        <>
                                            <label style={{color:"#F00"}}>منقضی شده</label>
                                            <br/>
                                            <label style={{color:"#000"}}>مبلغ تمدید : {util.toPersianDigits(util.SeperatePrice(c.contract.nextRecontinuePrice))}</label>
                                        </>
                                    }
                                    
                                </Col>
                                <Col md="4" style={{textAlign:"right"}}>
                                    <Button severity="Primary" onClick={()=>{btnRecontinueClick(c, cInd)}} style={{borderRadius:"5px"}}>تمدید قرارداد</Button>
                                </Col>
                            </>
                            :<></>
                        }
                    </Row>
                    <Row style={{marginTop:"10px", borderBottom:"1px dashed #b0b0b0", paddingBottom:"10px"}}>
                        <Col md="4" style={{textAlign:"right"}}>
                            <Button severity="info" onClick={()=>{onContractRowPrintClick(c, cInd)}} icon="pi pi-print" style={{borderRadius:"5px"}}>&nbsp;&nbsp;چاپ</Button>
                        </Col>
                        {
                            (c.contract.product.enName == "TaxService")&&(c.contract.otherSystemIdentity != "")?
                            <Col md="4" style={{textAlign:"right"}}>
                                <Button severity="success" onClick={()=>{onActiveContractInOtherSystemClick(c, cInd)}} icon="pi pi-check" style={{borderRadius:"5px"}}>&nbsp;&nbsp;فعالسازی در سامانه مودیان</Button>
                                <br/>
                                اگر مجوز شما در سامانه مودیان مالیاتی هانا فعال نشده یا افزایش میزان اعتبار در آن سامانه اعمال نشده است، می توانید با کلیک بر روی دکمه فوق آنرا فعال نمائید
                            </Col>
                            :<></>
                        }
                    </Row>
                </Col>
            </Row>
        )
    }
    const editDialogFooter3 = function(){
        return (
            <GeneralDialogFooter hideOk={true} onOkClick={()=>{}} onCancelClick={()=>{setDownloadBillPdfFormVisible(false)}} saving={false} />
        )
    }
    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        (loading)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت لیست قرارداد ها..." />
                </Col>
            </Row>
        </>
        :(contracts.length == 0)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <table>
                        <tbody>
                            <tr><td style={{textAlign:"center"}}>تا کنون هیچ محصولی خرید نکرده اید</td></tr>
                            <tr><td style={{textAlign:"center", paddingTop:"20px"}}><Button severity="success" onClick={()=>{navigate('buy-product')}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;خرید اولین محصول&nbsp;&nbsp;</Button></td></tr>
                        </tbody>
                    </table>
                </Col>
            </Row>
        </>
        :
        <>
            <div style={{textAlign:"center", padding:"5px", backgroundColor:"#ccc", marginTop:"10px", borderTopRightRadius:"5px", borderTopLeftRadius:"5px"}}>
                لیست قراردادهای من
            </div>
            <Row style={{padding:"0px", margin:"0px 0px 0px 0px", position:"relative"}}>
                {
                    contracts.map((c, cInd)=>{
                        return(
                            <>{showContract(c, cInd)}</>
                        )
                    })
                }
            </Row>
            {
                downloadBillPdfFormVisible?
                <Dialog visible={true} style={{ width: '50rem', height:"calc(100vh - 100px)" }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                header="دانلود فاکتور قرارداد" modal className="p-fluid" footer={() => editDialogFooter3()} onHide={() => setDownloadBillPdfFormVisible(false)}>
                    {
                    billParams == null?
                    <>
                        <Row>
                            <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                                <Laoding showLable={true} label="در حال دریافت پارامترهای چاپ..." />
                            </Col>
                        </Row>
                    </>
                    :
                    printData == null?
                        contract.contract.transactions.map((tr, trInd)=>{
                            return(
                                <>
                                    <div style={{width:"calc(100% - 10px)", height:"98px", margin:"10px 0px", borderRadius:"5px", border:"1px solid #b0b0b0", padding:"5px", position:"relative"}}>
                                        <table style={{width:"100%", borderCollapse:"collapse"}}>
                                            <tbody>
                                                <tr>
                                                    <td style={{width:"100px", border:"1px dashed #d0d0d0", padding:"3px", textAlign:"center", fontWeight:"bold"}} colSpan={2}>{tr.transactionType.title}</td>
                                                    <td style={{textAlign:"center", verticalAlign:"middle"}} rowSpan={3}>
                                                        <Button label="&nbsp;&nbsp;  چاپ  &nbsp;&nbsp;" icon="pi pi-print" onClick={()=>printBill(trInd)} severity="info" iconPos="right" style={{borderRadius:"5px", width:"110px"}} />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{textAlign:"left", border:"1px dashed #d0d0d0", padding:"3px"}}>تاریخ</td>
                                                    <td style={{border:"1px dashed #d0d0d0", padding:"3px"}}>{util.toPersianDigits(util.SeperateDate(tr.transactionDate))}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{textAlign:"left", border:"1px dashed #d0d0d0", padding:"3px"}}>مبلغ</td>
                                                    <td style={{border:"1px dashed #d0d0d0", padding:"3px"}}>{util.toPersianDigits(util.SeperatePrice(tr.amount))}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )
                        })
                    :
                    <>
                        <Row>
                            <Col className="d-flex justify-content-center align-items-center" style={{height:"100px"}}>
                                جهت دانلود فایل صورتحساب بر روی لینک زیر کلیک نمائید
                            </Col>
                        </Row>
                        <Row>
                            <Col className="d-flex justify-content-center align-items-center" style={{height:"30px"}}>
                                <PDFDownloadLink  style={{textDecoration:"0px"}}
                                document={<PrintContraxtBill 
                                    data={{bill:printData, params:billParams}} 
                                    />} fileName={"hana_bill_"+util.generateRandomUString(10)+".pdf"}>
                                    <label style={{fontSize:"14pt", cursor:"pointer"}}>دانلود صورتحساب!</label>
                                </PDFDownloadLink>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="d-flex justify-content-center align-items-center" style={{height:"100px"}}>
                               <label style={{cursor:"pointer", color:"#5656e0"}} onClick={()=>setPrintData(null)}>برگشت به لیست چاپ</label>
                            </Col>
                        </Row>
                    </>
                    }
                </Dialog>
                :
                <></>
            }
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}